/**
 * 
 * @param {*} notificationDetails 
 * @returns object with the field warningType. This can be either:
 * 1) TRADE_PLAN_WARNING (warning related to a trade plan, such as you the stock you want to go short is on the etb list)
 * 2) LIQUIDITY_WARNING (such as if we are changing your market order to a limit order due to concerns about how thing what you are
 * trading seems to be)

 */
export function warningParser(notificationDetails) {
  const parsedObject = {
    warningType: null,
  };
  if (notificationDetails) {
    parsedObject.warningType = notificationDetails.warningType ?? null;
  }
  return parsedObject;
}
